

export const colourStyles = {
    menuList: styles => ({
        ...styles,
        background: "white",
    }),
    menu: base => ({
        ...base,
        zIndex: 1200,
    }),
}

export const locationOptions = [
    {label: "India", value: "India"},
    {label: "UK", value: "UK"},
]

export const statusOptions = [
    {label: "New", value: "New"},
    {label: "Introduction", value: "Introduction"},
    {label: "Meeting", value: "Meeting"},
    {label: "In Progress", value: "In Progress"},
    {label: "On Hold", value: "On Hold"},
    {label: "Lost", value: "Lost"},
]

export const assingOptions = [
    {label: "Rahul Ovhal", value: "Rahul Ovhal"},
    {label: "Janvi Bhagat", value: "Janvi Bhagat"},
    {label: "Zain Marchawala", value: "Zain Marchawala"},
    {label: "Mohit K", value: "Mohit K"},
    {label: "Nimesh Patel", value: "Nimesh Patel"},
]

export const contracts = [
    { label: "- Select -", value: "- Select -" },
    { label: "Global Biotech", value: "Global Biotech" },
    { label: "Global Infoteh", value: "Global Infoteh" },
    { label: "Indian Infotech", value: "Indian Infotech" },
  ]

export const countryOptions = [
    { label: "Afghanistan", value: "Afghanistan" },
    { label: "Albania", value: "Albania" },
    { label: "Algeria", value: "Algeria" },
    { label: "American Samoa", value: "American Samoa" },
    { label: "Andorra", value: "Andorra" },
    { label: "Angola", value: "Angola" },
    { label: "Anguilla", value: "Anguilla" },
    { label: "Antarctica", value: "Antarctica" },
    { label: "Argentina", value: "Argentina" },
    { label: "Armenia", value: "Armenia" },
    { label: "Aruba", value: "Aruba" },
    { label: "Australia", value: "Australia" },
    { label: "Austria", value: "Austria" },
    { label: "Azerbaijan", value: "Azerbaijan" },
    { label: "Bahamas", value: "Bahamas" },
    { label: "Bahrain", value: "Bahrain" },
    { label: "Bangladesh", value: "Bangladesh" },
    { label: "Barbados", value: "Barbados" },
    { label: "Belarus", value: "Belarus" },
    { label: "Belgium", value: "Belgium" },
    { label: "Belize", value: "Belize" },
    { label: "Benin", value: "Benin" },
    { label: "Bermuda", value: "Bermuda" },
    { label: "Bhutan", value: "Bhutan" },
    { label: "Bolivia", value: "Bolivia" },
    { label: "Botswana", value: "Botswana" },
    { label: "Bouvet Island", value: "Bouvet Island" },
    { label: "Brazil", value: "Brazil" },
    { label: "Brunei Darussalam", value: "Brunei Darussalam" },
    { label: "Bulgaria", value: "Bulgaria" },
    { label: "Burkina Faso", value: "Burkina Faso" },
    { label: "Burundi", value: "Burundi" },
    { label: "Cambodia", value: "Cambodia" },
    { label: "Cameroon", value: "Cameroon" },
    { label: "Canada", value: "Canada" },
    { label: "Cape Verde", value: "Cape Verde" },
    { label: "Cayman Islands", value: "Cayman Islands" },
    { label: "Central African Republic", value: "Central African Republic" },
    { label: "Chad", value: "Chad" },
    { label: "Chile", value: "Chile" },
    { label: "China", value: "China" },
    { label: "Christmas Island", value: "Christmas Island" },
    { label: "Cocos (Keeling) Islands", value: "Cocos (Keeling) Islands" },
    { label: "Colombia", value: "Colombia" },
    { label: "Comoros", value: "Comoros" },
    { label: "Congo", value: "Congo" },
    { label: "Cook Islands", value: "Cook Islands" },
    { label: "Costa Rica", value: "Costa Rica" },
    { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
    { label: "Croatia (Hrvatska)", value: "Croatia (Hrvatska)" },
    { label: "Cuba", value: "Cuba" },
    { label: "Cyprus", value: "Cyprus" },
    { label: "Czech Republic", value: "Czech Republic" },
    { label: "Denmark", value: "Denmark" },
    { label: "Djibouti", value: "Djibouti" },
    { label: "Dominica", value: "Dominica" },
    { label: "Dominican Republic", value: "Dominican Republic" },
    { label: "Ecuador", value: "Ecuador" },
    { label: "Egypt", value: "Egypt" },
    { label: "El Salvador", value: "El Salvador" },
    { label: "Equatorial Guinea", value: "Equatorial Guinea" },
    { label: "Eritrea", value: "Eritrea" },
    { label: "Estonia", value: "Estonia" },
    { label: "Ethiopia", value: "Ethiopia" },
    { label: "Falkland Islands (Malvinas)", value: "Falkland Islands (Malvinas)" },
    { label: "Faroe Islands", value: "Faroe Islands" },
    { label: "Fiji", value: "Fiji" },
    { label: "Finland", value: "Finland" },
    { label: "France", value: "France" },
    { label: "French Guiana", value: "French Guiana" },
    { label: "French Polynesia", value: "French Polynesia" },
    { label: "Gabon", value: "Gabon" },
    { label: "Gambia", value: "Gambia" },
    { label: "Georgia", value: "Georgia" },
    { label: "Germany", value: "Germany" },
    { label: "Ghana", value: "Ghana" },
    { label: "Gibraltar", value: "Gibraltar" },
    { label: "Greece", value: "Greece" },
    { label: "Greenland", value: "Greenland" },
    { label: "Grenada", value: "Grenada" },
    { label: "Guadeloupe", value: "Guadeloupe" },
    { label: "Guam", value: "Guam" },
    { label: "Guatemala", value: "Guatemala" },
    { label: "Guinea", value: "Guinea" },
    { label: "Guinea-Bissau", value: "Guinea-Bissau" },
    { label: "Guyana", value: "Guyana" },
    { label: "Haiti", value: "Haiti" },
    { label: "Honduras", value: "Honduras" },
    { label: "Hong Kong", value: "Hong Kong" },
    { label: "Hungary", value: "Hungary" },
    { label: "Iceland", value: "Iceland" },
    { label: "India", value: "India" },
    { label: "Indonesia", value: "Indonesia" },
    { label: "Iraq", value: "Iraq" },
    { label: "Ireland", value: "Ireland" },
    { label: "Israel", value: "Israel" },
    { label: "Italy", value: "Italy" },
    { label: "Jamaica", value: "Jamaica" },
    { label: "Japan", value: "Japan" },
    { label: "Jordan", value: "Jordan" },
    { label: "Kazakhstan", value: "Kazakhstan" },
    { label: "Kenya", value: "Kenya" },
    { label: "Kiribati", value: "Kiribati" },
    { label: "Korea, Republic of", value: "Korea, Republic of" },
    { label: "Kuwait", value: "Kuwait" },
    { label: "Kyrgyzstan", value: "Kyrgyzstan" },
    { label: "Latvia", value: "Latvia" },
    { label: "Lebanon", value: "Lebanon" },
    { label: "Lesotho", value: "Lesotho" },
    { label: "Liberia", value: "Liberia" },
    { label: "Libyan Arab Jamahiriya", value: "Libyan Arab Jamahiriya" },
    { label: "Liechtenstein", value: "Liechtenstein" },
    { label: "Lithuania", value: "Lithuania" },
    { label: "Luxembourg", value: "Luxembourg" },
    { label: "Macau", value: "Macau" },
    { label: "Madagascar", value: "Madagascar" },
    { label: "Malawi", value: "Malawi" },
    { label: "Malaysia", value: "Malaysia" },
    { label: "Maldives", value: "Maldives" },
    { label: "Mali", value: "Mali" },
    { label: "Malta", value: "Malta" },
    { label: "Marshall Islands", value: "Marshall Islands" },
    { label: "Martinique", value: "Martinique" },
    { label: "Mauritania", value: "Mauritania" },
    { label: "Mauritius", value: "Mauritius" },
    { label: "Mayotte", value: "Mayotte" },
    { label: "Mexico", value: "Mexico" },
    { label: "Moldova, Republic of", value: "Moldova, Republic of" },
   
]

export const stateOptions = [
    { label: "Alabama", value: "Alabama" },
    { label: "Alaska", value: "Alaska" },
    { label: "Arizona", value: "Arizona" },
    { label: "Arkansas", value: "Arkansas" },
    { label: "California", value: "California" },
    { label: "Colorado", value: "Colorado" },
    { label: "Connecticut", value: "Connecticut" },
    { label: "Delaware", value: "Delaware" },
    { label: "Florida", value: "Florida" },
    { label: "Georgia", value: "Georgia" },
    { label: "Hawaii", value: "Hawaii" },
    { label: "Idaho", value: "Idaho" },
    { label: "Illinois", value: "Illinois" },
    { label: "Indiana", value: "Indiana" },
    { label: "Iowa", value: "Iowa" },
    { label: "Kansas", value: "Kansas" },
    { label: "Kentucky", value: "Kentucky" },
    { label: "Louisiana", value: "Louisiana" },
    { label: "Maine", value: "Maine" },
    { label: "Maryland", value: "Maryland" },
    { label: "Massachusetts", value: "Massachusetts" },
    { label: "Michigan", value: "Michigan" },
    { label: "Minnesota", value: "Minnesota" },
    { label: "Mississippi", value: "Mississippi" },
    { label: "Missouri", value: "Missouri" },
    { label: "Montana", value: "Montana" },
    { label: "Nebraska", value: "Nebraska" },
    { label: "Nevada", value: "Nevada" },
    { label: "New Hampshire", value: "New Hampshire" },
    { label: "New Jersey", value: "New Jersey" },
    { label: "New Mexico", value: "New Mexico" },
    { label: "New York", value: "New York" },
    { label: "North Carolina", value: "North Carolina" },
    { label: "North Dakota", value: "North Dakota" },
    { label: "Ohio", value: "Ohio" },
    { label: "Oklahoma", value: "Oklahoma" },
    { label: "Oregon", value: "Oregon" },
    { label: "Pennsylvania", value: "Pennsylvania" },
    { label: "Rhode Island", value: "Rhode Island" },
    { label: "South Carolina", value: "South Carolina" },
    { label: "South Dakota", value: "South Dakota" },
    { label: "Tennessee", value: "Tennessee" },
    { label: "Texas", value: "Texas" },
    { label: "Utah", value: "Utah" },
    { label: "Vermont", value: "Vermont" },
    { label: "Virginia", value: "Virginia" },
    { label: "Washington", value: "Washington" },
    { label: "West Virginia", value: "West Virginia" },
    { label: "Wisconsin", value: "Wisconsin" },
    { label: "Wyoming", value: "Wyoming" }
]

export const cityOptions = [
    { label: "New York", value: "New York" },
    { label: "Los Angeles", value: "Los Angeles" },
    { label: "Chicago", value: "Chicago" },
    { label: "Houston", value: "Houston" },
    { label: "Phoenix", value: "Phoenix" },
    { label: "Philadelphia", value: "Philadelphia" },
    { label: "San Antonio", value: "San Antonio" },
    { label: "San Diego", value: "San Diego" },
    { label: "Dallas", value: "Dallas" },
    { label: "San Jose", value: "San Jose" },
    { label: "Austin", value: "Austin" },
    { label: "Jacksonville", value: "Jacksonville" },
    { label: "Fort Worth", value: "Fort Worth" },
    { label: "Columbus", value: "Columbus" },
    { label: "Charlotte", value: "Charlotte" },
    { label: "San Francisco", value: "San Francisco" },
    { label: "Indianapolis", value: "Indianapolis" },
    { label: "Seattle", value: "Seattle" },
    { label: "Denver", value: "Denver" },
    { label: "Washington", value: "Washington" },
    { label: "Boston", value: "Boston" },
    { label: "El Paso", value: "El Paso" },
    { label: "Nashville", value: "Nashville" },
    { label: "Detroit", value: "Detroit" },
    { label: "Oklahoma City", value: "Oklahoma City" },
    { label: "Portland", value: "Portland" },
    { label: "Las Vegas", value: "Las Vegas" },
    { label: "Memphis", value: "Memphis" },
    { label: "Louisville", value: "Louisville" },
    { label: "Baltimore", value: "Baltimore" },
    { label: "Milwaukee", value: "Milwaukee" },
    { label: "Albuquerque", value: "Albuquerque" },
    { label: "Tucson", value: "Tucson" },
    { label: "Fresno", value: "Fresno" },
    { label: "Sacramento", value: "Sacramento" },
    { label: "Mesa", value: "Mesa" },
    { label: "Kansas City", value: "Kansas City" },
    { label: "Atlanta", value: "Atlanta" },
    { label: "Miami", value: "Miami" },
    { label: "Colorado Springs", value: "Colorado Springs" },
    { label: "Raleigh", value: "Raleigh" },
    { label: "Long Beach", value: "Long Beach" },
    { label: "Virginia Beach", value: "Virginia Beach" },
    { label: "Omaha", value: "Omaha" },
    { label: "Oakland", value: "Oakland" },
    { label: "Minneapolis", value: "Minneapolis" },
    { label: "Tulsa", value: "Tulsa" },
    { label: "Arlington", value: "Arlington" },
    { label: "New Orleans", value: "New Orleans" },
    { label: "Wichita", value: "Wichita" },
    { label: "Cleveland", value: "Cleveland" }
]

  export const customer = [
    { label: "Gujarat", value: "1" },
    { label: "Zithas", value: "2" },
    { label: "jinal", value: "3" },
  ]
  export const invoice_type = [
    { label: "Project / Resource", value: "1" },
    { label: "Hosting", value: "2" },
    { label: "Mainetance", value: "3" },
  ]
  export const location = [
    { label: "India", value: "1" },
    { label: "UK", value: "2" },
  ]

  export const payments = [
    { label: "Bank Account", value: "1" },
    { label: "Credit Card", value: "2" },
    { label: "Other", value: "3" },
  ]

  export const projects = [
    { label: "Earth Development", value: "1" },
    { label: "Mars Development", value: "2" },
    { label: "Jen Therapy", value: "3" },
  ]

  export const currency = [
    { label: "AUD", value: "1" },
    { label: "INR", value: "2" },
    { label: "USD", value: "3" },
    { label: "AED", value: "4" },
  ]
  export const discount_type = [
    { label: "Percentage %", value: "1" },
    { label: "Fixed", value: "2" },
  ]
  export const terms = [
    { label: "Due on Receipt", value: "1" },
    { label: "Due in 15 days", value: "2" },
  ]


  export const KeyAccountManager = [
    { label: "Rahul Ovhal", value: "1" },
    { label: "Zain", value: "2" },
    { label: "Manav", value: "3" },
  ]
  export const status_option = [
    { label: "Not Answered", value: "Not Answered" },
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "Answered", value: "Answered" },
    { label: "On Hold", value: "On Hold" },
    { label: "Closed", value: "Closed" },
  ]


  export const assignee = [
    { label: "Rahul Ovhal", value: "1" },
    { label: "Zain Marchawala", value: "2" },
    { label: "Manav", value: "3" },
  ]

  export const priority = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ]
  export const Type = [
    { label: "Bug", value: "0" },
    { label: "Suggestion", value: "1" },
  ]

  export const related = [
    { label: "Project", value: "Project" },
    { label: "Contract", value: "Contract" },
  ]
  export const project_type = [
    { label: "Earth", value: "Earth" },
    { label: "Mars", value: "Mars" },
  ]

  export const customerOptions = [
    {label : "Zithas Technologies Private Limited", value :"Zithas Technologies Private Limited"},
    {label : "Mr. Jean", value :"Mr. Jean"},
    {label : "W-Hensons", value :"W-Hensons"},
  ]